import styled, { createGlobalStyle } from "styled-components";
import {
  GrayColors,
  SolutionColorVariables,
  TextColorNames,
} from "@smartsuite/types";

export const ModalBodyWrapper = styled.div<{ isFirstRender: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-radius: 8px;
  padding: 15px;

  ${(props) =>
    props?.isFirstRender ? `gap: 4px; padding: 12px 5px 5px;` : ""};
`;

export const ModalItem = styled.div`
  display: flex;
  height: 28px;
  cursor: pointer;
  align-items: center;
  padding: 0 12px;
  gap: 8px;
  border-radius: 5px;
  &:hover {
    background-color: ${GrayColors["G-1"]};
  }

  .modal-item-text {
    color: ${TextColorNames.tertiary};
    transition: color 200ms ease-in-out;
  }

  &:hover {
    .modal-item-text {
      color: ${TextColorNames.primary};
      transition: color 150ms ease-in;
    }
  }
`;

export const ModalTitle = styled.div`
  display: inline-flex;
  color: ${TextColorNames.secondary};
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  padding-left: 12px;
`;

export const StyledTitle = styled.div<{
  largeCaption?: boolean;
  open?: boolean;
}>`
  font-family: inherit;
  font-size: ${(props) => (props?.largeCaption ? "18px" : "14px")};
  line-height: ${(props) => (props?.largeCaption ? "25px" : "18px")};
  font-weight: 500;
  display: inline-block;
  color: ${(props) =>
    props?.open === true ? SolutionColorVariables.sc1 : TextColorNames.primary};
`;

export const GlobalStyle = createGlobalStyle`
  .flat-modal-items {
    width: 330px;
    margin-left: 8px;
  }
`;
